<template>
  <div class="home-swiper-container" v-if="isShow">
    <swiper :options="howToSwiper">
      <swiper-slide class="home-swiper-card" v-for="(p, idx) in item.Products" :key="'mySwiperSlide__'+idx" v-if="!p.IsStopSale">
        <productCard
          v-bind:img="p.Thumbnail"
          v-bind:link="p.link"
          v-bind:brand="p.Brand"
          v-bind:rating="p.Rating"
          v-bind:name="p.Name"
          v-bind:description="p.Description"
          v-bind:refNum="p.RefNum"
          v-bind:isPromotion="p.IsPromotion"
          v-bind:price="p.Price"
          v-bind:item="p"
          v-bind:quantity="p.Quantity"
          v-bind:packageSize="p.PackageSize"
          v-bind:hidePrice="true"
          v-bind:key="'productCard_'+idx"
          v-bind:isZoom="false"
        ></productCard>
      </swiper-slide>
    </swiper>
    <!-- <div class="swiper-button-prev" :class="`swiper-button-prev-${index}`" slot="button-prev">
      <font-awesome-icon icon="chevron-left" :style="{ color: '#ddc983', fontSize: '40px', marginRight: '60px' }"/>
    </div>
    <div class="swiper-button-next" :class="`swiper-button-next-${index}`" slot="button-next">
      <font-awesome-icon icon="chevron-right" :style="{ color: '#ddc983', fontSize: '40px', marginLeft: '60px'  }"/>
    </div> -->
  </div>
</template>

<script>
import productCard from "../../view/productCard";
import {locales} from "../../mixin";

export default {
  name: "home-swiper",
  mixins: [locales],
  components: {
    productCard
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      howToSwiper: {},
      isShow: false
    }
  },
  mounted() {
    this.howToSwiper = {
      slidesPerView: 5,
      spaceBetween: 20,
      allowTouchMove: false,
      simulateTouch: false,
      navigation: {
        prevEl: `.swiper-button-prev-${this.index}`,
        nextEl: `.swiper-button-next-${this.index}`,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        //when width >= 480
        480: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 14,
        },
        //when width >= 640
        990: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      }
    }
    this.isShow = true
  }
}
</script>

<style lang="less">
.home-swiper-container {
  position: relative;

  .swiper-button-prev,
  .swiper-button-next {
    top: 50% !important;
    margin-top: 0;
    transform: translateY(-50%);
  }

  .home-swiper-card{
    height: 310px;
    padding: 12px;
    background: rgba(255, 253, 243, 0.9);
    border: 2px solid #ebe3c6;
    border-radius: 12px;
    box-shadow: 4px 4px 8px -2px rgba(83, 70, 28, 0.12);
    text-align: center;

    .product-card,
    .product_box {
      height: 100%;
    }

    .product_box {
      display: flex;
      flex-direction: column;
    }

    .ProImg {
      flex: 0 0 160px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 160px;
      margin: 0 auto 8px;
      border-radius: 6px;

      > a {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 0 !important;
      }

      img.is-fallback-logo {
        width: 100%;
        // max-width: 190px;
      }
    }

    .Pro-Details,
    .price-bot,
    .refNum-name,
    .ProTitle,
    .packageSize,
    .price-marge {
      width: 100%;
      text-align: center !important;
    }

    .Pro-Details {
      padding: 3px 8px 6px;
    }

    .refNum-name{
      margin-bottom: 3px;
      color: #56552a;
      font-size: 18px !important;
      font-weight: 800;
    }
    .product-card-name{
      color: #3e3d26;
      font-size: 16px !important;
    }
    .packageSize{
      margin-top: 6px;
      color: #53512c;
      font-size: 15px !important;
    }
    .refNum-name,
    .product-card-name,
    .packageSize {
      font-family: 'Do Hyeon', sans-serif !important;
    }

    .price-bot {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .product-card .Pro-Details .price-bot .price-marge {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-right: auto;
      margin-left: auto;
      text-align: center !important;

      .price__regular,
      .price_original {
        float: none;
      }
    }

    .ProTitle {
      float: none;

      a {
        float: none;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-swiper/home-swiper.vue